import { ISuggestV2Response } from 'shared/repositories/geo-suggest/entities/entities/SuggestV2Response';
import { EGeoSuggestStatus } from 'shared/services/geoSuggest';

export const prepareGeoSuggest = (response: ISuggestV2Response) => {
  return {
    data: response.data,
    message: null,
    status: EGeoSuggestStatus.Success,
  };
};
